import { render, staticRenderFns } from "./FieldsetAddress.yaml?vue&type=template&id=1bf9ac17&component"
import script from "./FieldsetAddress.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetAddress.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports